import { TranslationObject } from '../../i18n/translation';

const namespace = 'agreementpermits';

const translations: TranslationObject = {
  sharePersonnummerCheckbox: {
    id: `${namespace}.sharePersonnummer`,
    nb: 'Tillat administratorer ved praksisstedene å laste ned studentlister med fødselsnummer, etter gjennomført studentfordeling.',
    en: 'Allow administrators at the workplaces to download studentlists containing national identity numbers, after assigning work placements.',
  },
};

export default translations;
